import { DatePipe } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';

@Component({
  selector: 'app-roster-shift',
  templateUrl: './roster-shift.component.html',
  styleUrls: ['./roster-shift.component.scss']
})
export class RosterShiftComponent {
  @Input() dataType!: string;
  // if day then every 3 day
  public repeatArr: any[] = [
    { name: "First Sunday", value: '[0,0]' },
    { name: "First Monday", value: '[0,1]' },
    { name: "First Tuesday", value: '[0,2]' },
    { name: "First Wednesday", value: '[0,3]' },
    { name: "First Thursday", value: '[0,4]' },
    { name: "First Friday", value: '[0,5]' },
    { name: "First Saturday", value: '[0,6]' },
    { name: "Second Sunday", value: '[1,0]' },
    { name: "Second Monday", value: '[1,1]' },
    { name: "Second Tuesday", value: '[1,2]' },
    { name: "Second Wednesday", value: '[1,3]' },
    { name: "Second Thursday", value: '[1,4]' },
    { name: "Second Friday", value: '[1,5]' },
    { name: "Second Saturday", value: '[1,6]' },
    { name: "Last Sunday", value: '[3,0]' },
    { name: "Last Monday", value: '[3,1]' },
    { name: "Last Tuesday", value: '[3,2]' },
    { name: "Last Wednesday", value: '[3,3]' },
    { name: "Last Thursday", value: '[3,4]' },
    { name: "Last Friday", value: '[3,5]' },
    { name: "Last Saturday", value: '[3,6]' },
    { name: "1st", value: '[1]' },
    { name: "2nd", value: '[2]' },
    { name: "3rd", value: '[3]' },
    { name: "4th", value: '[4]' },
    { name: "5th", value: '[5]' },
    { name: "6th", value: '[6]' },
    { name: "7th", value: '[7]' },
    { name: "8th", value: '[8]' },
    { name: "9th", value: '[9]' },
    { name: "10th", value: '[10]' },
    { name: "11th", value: '[11]' },
    { name: "12th", value: '[12]' },
    { name: "13th", value: '[13]' },
    { name: "14th", value: '[14]' },
    { name: "15th", value: '[15]' },
    { name: "16th", value: '[16]' },
    { name: "17th", value: '[17]' },
    { name: "18th", value: '[18]' },
    { name: "19th", value: '[19]' },
    { name: "20th", value: '[20]' },
    { name: "21st", value: '[21]' },
    { name: "22nd", value: '[22]' },
    { name: "23rd", value: '[23]' },
    { name: "24th", value: '[24]' },
    { name: "25th", value: '[25]' },
    { name: "26th", value: '[26]' },
    { name: "27th", value: '[27]' },
    { name: "28th", value: '[28]' },
    { name: "29th", value: '[29]' },
    { name: "30th", value: '[30]' },
    { name: "31st", value: '[31]' },
  ]
  public weekdaysArr: any[] = [
    { name: "Sunday", val: "S", value: 0 },
    { name: "Monday", val: "M", value: 1 },
    { name: "Tuesday", val: "T", value: 2 },
    { name: "Wednesday", val: "W", value: 3 },
    { name: "Thursday", val: "T", value: 4 },
    { name: "Friday", val: "F", value: 5 },
    { name: "Saturday", val: "S", value: 6 },
  ]
  public frequencyType!: string;
  public endType!: string;
  public addForm!: FormGroup;
  public repeatEveryArr: any[] = [];
  public weekFrequency: any[] = [];

  public repeatsOnArr: any[] = []

  public monthFrequency!: string;

  constructor(private dialogRef: MatDialogRef<RosterShiftComponent>, private fb: FormBuilder, private datePipe: DatePipe, private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }
  ngOnInit() {

    this.addForm = this.fb.group({
      'frequency': ['', Validators.required],
      'monthFrequency': [''],
      'every': ['', Validators.required],
      // 'weekFrequency':[''],
      'endFrequency': ['', Validators.required],
      'endDate': [''],
      'occurrences': ['']
    })

    this.addForm.get('endFrequency')?.valueChanges.subscribe(value => {
      if (value == 0) {
        this.addForm.get('endDate')?.setValidators([Validators.required]);
        this.addForm.get('occurrences')?.setValidators([]);
      } else {
        this.addForm.get('endDate')?.setValidators([]);
        this.addForm.get('occurrences')?.setValidators([Validators.required]);
      }
      this.addForm.get('endDate')?.updateValueAndValidity();
      this.addForm.get('occurrences')?.updateValueAndValidity();
    });

    this.addForm.get('frequency')?.valueChanges.subscribe(value => {
      if (value == 0) {
        this.addForm.get('monthFrequency')?.setValidators([Validators.required]);
      } else {
        this.addForm.get('monthFrequency')?.setValidators([]);
      }
      this.addForm.get('monthFrequency')?.updateValueAndValidity();
    });

    if (this.dialogData) {

      const { r_typ, r_val, end_rtyp, end_r, r_on } = this.dialogData;
      let nr_typ = typeof r_typ === "string" ? r_typ : JSON.stringify(r_typ);
      let nend_r = typeof end_rtyp ==="string" ? end_rtyp : JSON.stringify(end_rtyp);

      this.addForm.get('frequency')?.setValue(nr_typ);
      this.getFrequencyType(r_typ);
      this.addForm.get('every')?.setValue(r_val);
      this.addForm.get('endFrequency')?.setValue(nend_r);

      if (nend_r === '1') {
        this.endType = 'after';
        this.addForm.get('occurrences')?.setValue(end_r);
      } else {
        this.endType = 'on';
        this.addForm.get('endDate')?.setValue(end_r);
      }

      if (this.frequencyType === 'monthly') {
        this.addForm.get('monthFrequency')?.setValue(r_on);
      } else if (this.frequencyType === 'weekly') {
        this.weekdaysArr = this.weekdaysArr.map(item => {
          // const isSelected = r_on.includes(item.value);
          const isSelected = r_on.includes(item.name); // here value was not working as names were coming from the add shift component
          //have changed node from value to name
          if (isSelected) this.repeatsOnArr.push(item.value);
          return { ...item, isSelected };
        });
      }
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onSelectFrequency(event) {
    let value = event.value
    this.getFrequencyType(value)
  }
  getFrequencyType(value: string | number) {
    if (value == 0) {
      this.frequencyType = 'monthly'
    }
    else if (value == 1) {
      this.frequencyType = 'weekly'
    }
    else {
      this.frequencyType = 'daily'
    }
    // this.frequencyType=event.value;
    this.getRepeatEveryArr()
  }
  getRepeatEveryArr() {
    this.repeatEveryArr = []
    if (this.frequencyType == 'daily') {
      this.repeatEveryArr = Array.from({ length: 30 }, (_, i) => i + 1);
    }
    else if (this.frequencyType == 'monthly') {
      this.repeatEveryArr = Array.from({ length: 12 }, (_, i) => i + 1);
    }
    else {
      this.repeatEveryArr = Array.from({ length: 20 }, (_, i) => i + 1);
    }
    // if(this.addForm.get())
    this.addForm.get('every')?.setValue(this.repeatEveryArr[0]);
  }
  onEndType(event) {
    if (event.value == '1') {
      this.endType = "after"
    }
    else {
      this.endType = "on"
    }
  }
  onSelectDay(item) {
    if (!item.hasOwnProperty('isSelected')) {
      item.isSelected = true
    }
    else {
      item.isSelected = !item.isSelected;
    }
    const days = this.weekFrequency;
    const index = days.indexOf(item.name);
    if (index > -1) {
      days.splice(index, 1);
    } else {
      days.push(item.name);
    }
    this.repeatsOnArr = days;
  }
  onCancel() {
    this.dialogRef.close()
  }
  onSelectRepeatMonth(event) {
    let item = this.repeatArr.find(item => item.value == event.value)
    this.monthFrequency = item.name;
  }
  onSubmit() {
    let data = this.addForm.value;
    if (this.weekFrequency.length > 0) {
      data["weekFrequency"] = this.weekFrequency
    }
    data["endDate"] = this.datePipe.transform(this.addForm.get('endDate')?.value, 'dd/MM/yyyy');
    let rosterData = {
      "repeat": "1", //1 = yes, 0 = no
      "r_typ": this.addForm.get('frequency')?.value, //2=daily,1=weekly,0=monthly,
      "r_val": this.addForm.get('every')?.value, //every some times       
      "end_rtyp": this.addForm.get('endFrequency')?.value, // 1=after, 0=on
      "r_on": [28], //[0,2,1] = weekly 
      "end_r": "3",
    }
    rosterData["end_r"] = this.endType == 'after' ?
      this.addForm.get('occurrences')?.value : this.datePipe.transform(this.addForm.get('endDate')?.value, 'yyyy-MM-dd');

    rosterData["r_on"] = this.frequencyType == 'weekly' ? this.repeatsOnArr : this.addForm.get('monthFrequency')?.value;

    let repeatText: string;
    let fData = this.addForm.value;
    let fType = fData.frequency;
    // Map frequency types to their corresponding time units
    const frequencyMap = { '0': 'months', '1': 'weeks', '2': 'days' };
    // Construct the repeat text based on the frequency and interval
    repeatText = `Every ${fData.every} ${frequencyMap[fType]}`;
    // Append month frequency if it exists
    if (fData.monthFrequency && frequencyMap[fType] == 'months') {
      repeatText += ` on ${this.monthFrequency}`;
    }
    // Append week frequency if it exists
    if (fData.weekFrequency) {
      repeatText += ` on ${fData.weekFrequency.join(', ')}`;
    }
    // Handle end frequency conditions
    if (fData.endFrequency == 0) {
      repeatText += ` until ${fData.endDate}`;
    } else if (fData.endFrequency == 1) {
      repeatText += ` for ${fData.occurrences} times`;
    }
    let objData = {
      data: rosterData,
      repeatText: repeatText
    }
    if (this.addForm.valid == false) {
      this.addForm.markAllAsTouched();
    }
    else {
      this.dialogRef.close({ data: objData, result: 'confirm' });
    }
  }
}